/*
  GTH cart — AJAX add for forms the theme does not manage.
  Rewritten 5 Aug 2026.

  WHY THIS EXISTS
  Several sections (artisan rails, vault cards, seasonal B, collection trial and
  the Boost grids) render their own hand-rolled <form action="/cart/add">. The
  theme's add-to-cart controller only binds to buttons inside
  [data-add-action-wrapper], so those forms fall through to a native browser POST
  and the customer is thrown onto /cart. This intercepts them instead.

  WHY IT IS SAFE TO BE GREEDY
  When the theme DOES manage a form it binds on the button's click and calls
  preventDefault(), so no submit event is ever emitted. Anything that actually
  reaches this listener is by definition unmanaged. The single exception is the
  theme's own escape hatch, [data-ajax-disable="true"], which we honour.

  AFTER A SUCCESSFUL ADD we speak the theme's own language rather than
  reimplementing its UI (event names verified against assets/theme.js):
    theme:cart:change on document, bubbles, detail.cart  -> header counts,
                                                            free-shipping bar,
                                                            drawer marked stale
    theme:cart:reload on document, bubbles               -> drawer refetches
                                                            ?section_id=api-cart-items
    theme:drawer:open on the drawer node, no bubbles     -> opens the drawer
  Order matters: change before reload, or the drawer can render itself empty.

  Falls back to a full navigation to /cart if no drawer is present (i.e. if the
  Cart type theme setting is ever put back to Page), and falls back to a native
  form submit on any error so an add is never silently lost.

  Loaded once from snippets/scoop-bag-auto-add.liquid. gth-seasonal.liquid and
  gth-brewing.liquid also load it, hence the init guard.
*/
(function () {
  if (window.__gthCartInit) return;
  window.__gthCartInit = true;

  var HDR = { 'X-Gth-Cart': '1' };

  function isOurs(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return false;
    if (form.querySelector('[type="file"]')) return false;
    if (document.querySelector('[data-ajax-disable="true"]')) return false;
    return true;
  }

  function announce() {
    return fetch('/cart.js', { headers: HDR })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        return cart;
      });
  }

  function openDrawer() {
    var d = document.querySelector('[data-drawer="drawer-cart"]');
    if (!d) return false;
    d.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    return true;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isOurs(form)) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"]') || form.querySelector('button');
    var original = button ? button.innerHTML : null;
    var adding = button && button.getAttribute('data-adding-label');
    if (button) {
      button.setAttribute('disabled', 'disabled');
      if (adding) button.innerHTML = adding;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest', 'X-Gth-Cart': '1' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(announce)
      .then(function () {
        if (button) {
          button.removeAttribute('disabled');
          var added = button.getAttribute('data-added-label');
          if (added) {
            button.innerHTML = added;
            setTimeout(function () { button.innerHTML = original; }, 2200);
          } else if (original !== null) {
            button.innerHTML = original;
          }
        }
        if (!openDrawer()) window.location = '/cart';
      })
      .catch(function () {
        if (button) {
          button.removeAttribute('disabled');
          if (original !== null) button.innerHTML = original;
        }
        form.submit();
      });
  }, true);
})();
